/**
 * The document lookup's address — the one per-document tool that is NOT part of a shop's file.
 *
 * It stays a sidebar destination of its own because it is the one tool that works ACROSS shops:
 * a merchant quotes "RE-26392" and the agent does not yet know, or need to know, which shop's file
 * to open. Scoped to one shop (`?shop=`), it is what the ticket page hands an agent.
 *
 * JSX-free on purpose, like the rest of `src/lib`: the dashboard's Jest runs in `node` with no
 * jsdom, so the paths every link is built from are only testable if they live outside a component.
 */

/** The lookup's route. */
export const DOCUMENT_LOOKUP_PATH = '/documents';

/**
 * The lookup, optionally scoped to one shop. Keyed by shop ID — the lookup reads documents the
 * way THIS shop numbers them rather than guessing at the prefix.
 */
export function documentLookupPath(shopId?: string): string {
  return shopId
    ? `${DOCUMENT_LOOKUP_PATH}?shop=${encodeURIComponent(shopId)}`
    : DOCUMENT_LOOKUP_PATH;
}
